import React, { FC } from 'react';
import { IconProps } from '../types';
import { iconDefaultProps } from '../const';
import { colors } from '../../../const/color';
import IconNonFilledStyled from '../icon-non-fill.styled';

const IconBandAid: FC<IconProps> = ({ $size, ...rest }) => (
  <IconNonFilledStyled {...{ $size, ...rest }}>
    <svg xmlns="http://www.w3.org/2000/svg" width={'100%'} height={'100%'} viewBox="0 0 32 32" fill="none">
      <circle cx="16" cy="16" r="16" fill="white" />
      <path
        d="M6.17497 11.825C5.48553 11.0641 5.1151 10.0672 5.14037 9.04074C5.16565 8.01426 5.58469 7.03681 6.31073 6.31076C7.03678 5.58472 8.01423 5.16568 9.04071 5.1404C10.0672 5.11513 11.0641 5.48556 11.825 6.175L25.825 20.175C26.5144 20.9359 26.8848 21.9328 26.8596 22.9593C26.8343 23.9857 26.4152 24.9632 25.6892 25.6892C24.9632 26.4153 23.9857 26.8343 22.9592 26.8596C21.9328 26.8849 20.9359 26.5144 20.175 25.825L6.17497 11.825Z"
        stroke={colors[rest?.$color]}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.175 6.175C20.9359 5.48556 21.9328 5.11513 22.9592 5.1404C23.9857 5.16568 24.9632 5.58472 25.6892 6.31076C26.4152 7.03681 26.8343 8.01426 26.8596 9.04074C26.8848 10.0672 26.5144 11.0641 25.825 11.825L11.825 25.825C11.0641 26.5144 10.0672 26.8849 9.04071 26.8596C8.01423 26.8343 7.03678 26.4153 6.31073 25.6892C5.58469 24.9632 5.16565 23.9857 5.14037 22.9593C5.1151 21.9328 5.48553 20.9359 6.17497 20.175L20.175 6.175Z"
        stroke={colors[rest?.$color]}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.5"
        d="M16 16.5C16.2761 16.5 16.5 16.2761 16.5 16C16.5 15.7239 16.2761 15.5 16 15.5C15.7239 15.5 15.5 15.7239 15.5 16C15.5 16.2761 15.7239 16.5 16 16.5Z"
        stroke={colors[rest?.$color]}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 17.5C16.8284 17.5 17.5 16.8284 17.5 16C17.5 15.1716 16.8284 14.5 16 14.5C15.1716 14.5 14.5 15.1716 14.5 16C14.5 16.8284 15.1716 17.5 16 17.5Z"
        fill={colors[rest?.$color]}
      />
    </svg>
  </IconNonFilledStyled>
);

IconBandAid.defaultProps = iconDefaultProps;
IconBandAid.displayName = 'IconBandAid';

export default IconBandAid;
